<template>
  <div class="attachment">
    <figure class="image thumbnail" @click="modalVisible = true">
      <img :src="attachment" alt />
    </figure>
    <div class="modal" :class="{'is-active': modalVisible}">
      <div class="modal-background" @click="modalVisible = false"></div>
      <div class="modal-content">
        <figure class="image">
          <img :src="attachment" alt />
        </figure>
      </div>
      <div class="modal-close" @click="modalVisible = false"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    attachment: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      modalVisible: false
    };
  }
};
</script>
<style lang="scss" scoped>
.attachment {
  .thumbnail {
    cursor: pointer;
    transform: scale(0.975);
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1);
    }
  }
}
</style>